import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import ArrowTickLeft from "../../../../../../../../media/images/icons/arrow-tick-left";
import goldCoin from "../../../../../../../../media/images/icons/goldCoin.png";
import monyAchivment from "../../../../../../../../media/images/icons/monyAchivment.png";
import silverCoin from "../../../../../../../../media/images/icons/silverCoin.png";

export default function Achivments() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        marginTop: "40px",
        // border: "1px solid gray",
      }}
    >
      <Typography
        sx={{
          fontWeight: "600",
        }}
      >
        دستاوردها و افتخارات
      </Typography>

      <Box
        sx={{
          display: "flex",
          //   alignItems: "center",
          gap: "8px",
          mt: 2,
        }}
      >
        <Grid
          container
          sx={{
            display: "flex",
            gap: "4px",
            justifyContent: "space-between",
          }}
        >
          <Grid
            item
            xs={9.8}
            sx={
              {
                //   border: "1px solid gray",
              }
            }
          >
            <Box
              sx={{
                flex: 1,
                // border: "1px solid gray",
                display: "flex",
                alignItems: "center",
                padding: "8px",
                height: "100%",
                backgroundColor: "info.light",
                borderRadius: "8px",
                gap: "4px",
                boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
              }}
            >
              <Box
                sx={{
                  boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1)",
                  //   border: "1px solid gray",
                  backgroundColor: "#fff",
                  flex: "1",
                  padding: "4px",

                  borderRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  src={goldCoin}
                  alt=""
                />
                <Box>
                  <Typography
                    noWrap
                    sx={{
                      fontSize: "10px",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    550 محموله
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      textAlign: "center",
                      fontSize: "10px",
                      fontWeight: "600",
                    }}
                  >
                    موفق
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1)",
                  //   border: "1px solid gray",
                  backgroundColor: "#fff",
                  flex: "1",
                  padding: "4px",
                  borderRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  src={monyAchivment}
                  alt=""
                />
                <Box>
                  <Typography
                    noWrap
                    sx={{
                      fontSize: "10px",

                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    550 محموله
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      textAlign: "center",
                      fontSize: "10px",
                      fontWeight: "600",
                    }}
                  >
                    موفق
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1)",
                  //   border: "1px solid gray",
                  backgroundColor: "#fff",
                  flex: "1",
                  padding: "4px",

                  borderRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  src={silverCoin}
                  alt=""
                />
                <Box>
                  <Typography
                    noWrap
                    sx={{
                      fontSize: "10px",

                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    550 محموله
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      textAlign: "center",
                      fontSize: "10px",
                      fontWeight: "600",
                    }}
                  >
                    موفق
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1)",
                  //   border: "1px solid gray",
                  backgroundColor: "#fff",
                  flex: "1",
                  padding: "4px",

                  borderRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  src={goldCoin}
                  alt=""
                />
                <Box>
                  <Typography
                    noWrap
                    sx={{
                      fontSize: "10px",

                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    550 محموله
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      textAlign: "center",
                      fontSize: "10px",

                      fontWeight: "600",
                    }}
                  >
                    موفق
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={2}
            sx={
              {
                //   border: "1px solid gray",
              }
            }
          >
            <Link
              to={"#"}
              style={{
                height: "100%",
                padding: "16px 4px",
                display: "flex",
                gap: "8px",
                alignItems: "center",
                flexDirection: "column",
                borderRadius: "8px",
                backgroundColor: theme.palette.primary.main,
              }}
            >
              <ArrowTickLeft color="#fff" />
              <Box>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "14px",
                  }}
                >
                  مشاهده
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "14px",
                  }}
                >
                  افتخارات
                </Typography>
              </Box>
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
